import React, { useEffect } from "react";
import Button, { ButtonColorTypes } from "../shared-components/Button";
import TrashOutlineIcon from "../shared-components/icons/TrashOutlineIcon";
import { useUpdateArticleRating } from "../api/ItemsApi";
import { ArticleActions, ItemWithMetaData } from "../api/Items";
import LoadingSpinner from "../shared-components/LoadingSpinner";
import { useReportTimer } from "../reports/ReportDetailProvider";

type Props = {
  handleAction: (action: "remove" | "cancel" | "completed") => void;
  item: ItemWithMetaData;
};

const ButtonWebcontentAdd = ({ handleAction, item }: Props) => {
  const { resetTimer } = useReportTimer();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  function performAction() {
    setIsLoading(true);
    setTimeout(() => {
      handleAction("remove");
    }, 333);
  }

  const { mutate: updateArticleRating, isSuccess } = useUpdateArticleRating();

  function handleRemove() {
    updateArticleRating({
      item_uuid: item.item.external_id,
      article_action: ArticleActions.REMOVED,
    });
    resetTimer?.();
    performAction();
  }

  useEffect(() => {
    if (isSuccess) {
      handleAction("completed");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  if (isLoading) return <LoadingSpinner />;

  return (
    <>
      <div className="hover:bg-slate-200 rounded-md">
        <Button
          text={
            <div className="flex gap-3 items-center px-2 py-0.5 text-gray-500 ">
              <TrashOutlineIcon />
              <span className="text-gray-700">Remove</span>
            </div>
          }
          colorType={ButtonColorTypes.custom}
          onClick={handleRemove}
        />
      </div>
    </>
  );
};

export default ButtonWebcontentAdd;
